"use strict";
import React from "react";
var AutoConfirmedLoadHeader = React.createClass({
  render: function() {
    var invoice = this.props.carrierInvoice;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "load-detail__auto-confirmed-header",
        "data-component": "AutoConfirmedLoadHeader"
      },
      /* @__PURE__ */ React.createElement("h3", { className: "load-detail__invoice-header" }, this.invoiceTitle(invoice)),
      /* @__PURE__ */ React.createElement("h3", { className: "load-detail__invoice-status" }, this.invoiceStatus(invoice))
    );
  },
  invoiceTitle: function(invoice) {
    var text = "Load " + this.props.load.load.load_id + " auto-confirmed";
    return /* @__PURE__ */ React.createElement("span", { className: "load-detail__invoice-header-text" }, text);
  },
  invoiceStatus: function(invoice) {
    if (invoice) {
      return /* @__PURE__ */ React.createElement("span", { className: "load-detail__invoice-status-text" }, "Status: ", invoice.status);
    }
  }
});
export default AutoConfirmedLoadHeader;
